import React from "react";
import { hoverSfx } from "@/lib/sfx";

const ACCENTS = {
  turquoise: { rgb: "0,240,255", hex: "#00f0ff" },
  pink: { rgb: "255,0,127", hex: "#ff007f" },
  green: { rgb: "57,255,20", hex: "#39ff14" },
  purple: { rgb: "176,38,255", hex: "#b026ff" },
  yellow: { rgb: "234,255,0", hex: "#eaff00" },
  gold: { rgb: "255,215,0", hex: "#ffd700" },
};

export const accentColor = (a) => (ACCENTS[a] || ACCENTS.turquoise);

export const HoloCard = ({ accent = "turquoise", className = "", children, hover = true, testid, ...rest }) => {
  const c = accentColor(accent);
  return (
    <div
      data-testid={testid}
      className={`relative glass clip-corner border border-white/10 ${className}`}
      style={{ borderTop: `1px solid rgba(${c.rgb},0.55)`, boxShadow: `inset 0 1px 0 rgba(${c.rgb},0.15)` }}
      onMouseEnter={(e) => { hoverSfx(); hover && (e.currentTarget.style.boxShadow = `0 0 26px rgba(${c.rgb},0.22), inset 0 1px 0 rgba(${c.rgb},0.3)`); }}
      onMouseLeave={(e) => hover && (e.currentTarget.style.boxShadow = `inset 0 1px 0 rgba(${c.rgb},0.15)`)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const NeonButton = ({ accent = "turquoise", children, className = "", as: Comp = "button", ...rest }) => {
  const c = accentColor(accent);
  return (
    <Comp
      className={`group relative inline-flex items-center justify-center gap-2 font-mono-tech text-xs uppercase tracking-[0.2em] px-6 py-3 border border-white/20 text-white bg-transparent transition-colors duration-200 cursor-pointer ${className}`}
      style={{ "--c": c.hex, "--rgb": c.rgb }}
      onMouseEnter={(e) => { hoverSfx(); e.currentTarget.style.borderColor = c.hex; e.currentTarget.style.color = c.hex; e.currentTarget.style.boxShadow = `0 0 18px rgba(${c.rgb},0.4)`; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.boxShadow = "none"; }}
      {...rest}
    >
      {children}
    </Comp>
  );
};
